// Weight/Mass units data for conversion routes
export const weightUnits = [
  { id: 'kilogram', name: 'Kilogram', symbol: 'kg', plural: 'Kilograms', factor: 1 },
  { id: 'gram', name: 'Gram', symbol: 'g', plural: 'Grams', factor: 0.001 },
  { id: 'milligram', name: 'Milligram', symbol: 'mg', plural: 'Milligrams', factor: 0.000001 },
  { id: 'microgram', name: 'Microgram', symbol: 'μg', plural: 'Micrograms', factor: 0.000000001 },
  { id: 'metric-ton', name: 'Metric Ton', symbol: 't', plural: 'Metric Tons', factor: 1000 },
  { id: 'pound', name: 'Pound', symbol: 'lb', plural: 'Pounds', factor: 0.45359237 },
  { id: 'ounce', name: 'Ounce', symbol: 'oz', plural: 'Ounces', factor: 0.028349523125 },
  { id: 'carat', name: 'Carat', symbol: 'ct', plural: 'Carats', factor: 0.0002 },
  { id: 'ton-us', name: 'US Ton', symbol: 'ton', plural: 'US Tons', factor: 907.18474 },
  { id: 'ton-uk', name: 'UK Ton', symbol: 'long ton', plural: 'UK Tons', factor: 1016.0469088 },
  { id: 'stone', name: 'Stone', symbol: 'st', plural: 'Stones', factor: 6.35029318 },
];

// Popular conversions matching common usage
export const popularWeightConversions = [
  { from: 'kilogram', to: 'pound' },
  { from: 'pound', to: 'kilogram' },
  { from: 'gram', to: 'ounce' },
  { from: 'ounce', to: 'gram' },
  { from: 'kilogram', to: 'stone' },
  { from: 'stone', to: 'kilogram' },
  { from: 'pound', to: 'ounce' },
  { from: 'ounce', to: 'pound' },
  { from: 'kilogram', to: 'gram' },
  { from: 'gram', to: 'kilogram' },
  { from: 'milligram', to: 'gram' },
  { from: 'gram', to: 'milligram' },
  { from: 'metric-ton', to: 'kilogram' },
  { from: 'kilogram', to: 'metric-ton' },
  { from: 'pound', to: 'stone' },
  { from: 'stone', to: 'pound' },
  { from: 'ton-us', to: 'kilogram' },
  { from: 'kilogram', to: 'ton-us' },
  { from: 'ton-uk', to: 'kilogram' },
  { from: 'kilogram', to: 'ton-uk' },
  { from: 'carat', to: 'gram' },
  { from: 'gram', to: 'carat' },
  { from: 'pound', to: 'gram' },
  { from: 'gram', to: 'pound' },
  { from: 'kilogram', to: 'ounce' },
  { from: 'ounce', to: 'kilogram' },
  { from: 'metric-ton', to: 'pound' },
  { from: 'pound', to: 'metric-ton' },
  { from: 'ton-us', to: 'metric-ton' },
  { from: 'metric-ton', to: 'ton-us' },
];

// Get unit by ID
export const getUnitById = (id) => {
  return weightUnits.find(unit => unit.id === id);
};

// Convert between units
export const convertWeight = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;

  // Convert to kilograms first, then to target unit
  const kilograms = value * fromUnit.factor;
  return kilograms / toUnit.factor;
};

// Format conversion slug to readable text
export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

// Generate SEO description
export const generateSEODescription = (fromUnit, toUnit) => {
  const sampleValue = 1;
  const result = convertWeight(sampleValue, fromUnit.id, toUnit.id);
  const formattedResult = result < 0.001 || result > 1000000
    ? result.toExponential(4)
    : result.toPrecision(6).replace(/\.?0+$/, '');

  return `Convert ${fromUnit.plural} to ${toUnit.plural}. 1 ${fromUnit.name} = ${formattedResult} ${toUnit.plural}. Free online weight and mass unit converter.`;
};
